const goals = [
  ['/uploads/1/1/9/7/119720466/e-web-goal-09_orig.png', 'ODS 9'],
  ['/uploads/1/1/9/7/119720466/e-web-goal-11_orig.png', 'ODS 11'],
  ['/uploads/1/1/9/7/119720466/e-web-goal-12_orig.png', 'ODS 12'],
  ['/uploads/1/1/9/7/119720466/e-web-goal-13_orig.png', 'ODS 13'],
];

const processImages = [
  '/uploads/1/1/9/7/119720466/peligrosos-25_orig.jpg',
  '/uploads/1/1/9/7/119720466/papel-25_orig.jpg',
  '/uploads/1/1/9/7/119720466/vidrio-25_orig.jpg',
  '/uploads/1/1/9/7/119720466/ferroso-25_orig.jpg',
  '/uploads/1/1/9/7/119720466/carton-25_orig.jpg',
  '/uploads/1/1/9/7/119720466/plastico-25_orig.jpg',
  '/uploads/1/1/9/7/119720466/noferroso-25_orig.jpg',
  '/uploads/1/1/9/7/119720466/madera-25_orig.jpg',
  '/uploads/1/1/9/7/119720466/electrico-25_orig.jpg',
];

const footprintImages = [
  '/uploads/1/1/9/7/119720466/recoleccion-25_orig.jpg',
  '/uploads/1/1/9/7/119720466/residuos-25_orig.jpg',
  '/uploads/1/1/9/7/119720466/huella-25_orig.jpg',
];

const ecoImages = {
  left: ['/uploads/1/1/9/7/119720466/auto-25_orig.jpg', '/uploads/1/1/9/7/119720466/camion-25_orig.jpg'],
  right: ['/uploads/1/1/9/7/119720466/casa-25_orig.jpg', '/uploads/1/1/9/7/119720466/arbol-25_orig.jpg'],
};

const clientColumns = [
  [
    { src: '/uploads/1/1/9/7/119720466/transbank_3.gif', href: 'https://www.transbank.cl', align: 'right', top: 10, bottom: 0 },
    { src: '/uploads/1/1/9/7/119720466/selecta-envases_1_orig.gif', href: 'http://selectaenvases.cl', align: 'right', top: 0, bottom: 0 },
    { src: '/uploads/1/1/9/7/119720466/peoplenet_orig.gif', href: 'http://www.peoplenet.cl', align: 'center', top: 10, bottom: 10 },
  ],
  [
    { src: '/uploads/1/1/9/7/119720466/bosch_orig.gif', href: 'https://www.bosch-home.cl', align: 'left', top: 10, bottom: 0 },
    { src: '/uploads/1/1/9/7/119720466/bci-seguros_1_orig.gif', href: 'https://www.bciseguros.cl', align: 'center', top: 0, bottom: 0 },
    { src: '/uploads/1/1/9/7/119720466/eus_orig.png', align: 'center', top: 10, bottom: 10 },
  ],
  [
    { src: '/uploads/1/1/9/7/119720466/ibm_3.gif', href: 'https://www.ibm.com/cl-es/', align: 'right', top: 10, bottom: 0 },
    { src: '/uploads/1/1/9/7/119720466/gasco_1_orig.gif', href: 'https://www.gasco.cl', align: 'center', top: 0, bottom: 0 },
    { src: '/uploads/1/1/9/7/119720466/maigas_orig.png', href: 'https://maigas.cl/', align: 'center', top: 10, bottom: 10 },
  ],
  [
    { src: '/uploads/1/1/9/7/119720466/colbun_orig.gif', href: 'https://www.colbun.cl', align: 'right', top: 10, bottom: 0 },
    { src: '/uploads/1/1/9/7/119720466/masaico_1_orig.gif', align: 'center', top: 0, bottom: 0 },
  ],
  [
    { src: '/uploads/1/1/9/7/119720466/scotiabank_orig.gif', href: 'https://www.scotiabankchile.cl', align: 'right', top: 10, bottom: 0 },
    { src: '/uploads/1/1/9/7/119720466/diebold_2_orig.gif', align: 'center', top: 0, bottom: 0 },
  ],
  [
    { src: '/uploads/1/1/9/7/119720466/loteria_1_orig.gif', href: 'https://www.loteria.cl/loterianet/', align: 'right', top: 10, bottom: 0 },
    { src: '/uploads/1/1/9/7/119720466/laser_orig.gif', align: 'center', top: 0, bottom: 10 },
  ],
  [
    { src: '/uploads/1/1/9/7/119720466/servipag_3.gif', href: 'https://www.servipag.com/wps/portal/servipag/home/!ut/p/b1/04_Sj9CPykssy0xPLMnMz0vMAfGjzOLd_YyCvTzNPJyD_fzNDTyNvY3dAkxCjC38zIAKIoEKDHAARwNC-sP1o_ArMYEqwGOFn0d-bqp-QW6EQZaJoyIAZ4d8Fw!!/dl4/d5/L2dBISEvZ0FBIS9nQSEh/', align: 'right', top: 10, bottom: 0 },
    { src: '/uploads/1/1/9/7/119720466/plan-vital_orig.gif', align: 'center', top: 0, bottom: 10 },
  ],
];

function renderClientLogoHtml({ src, href, align, top, bottom }) {
  const linkStart = href ? `<a href="${href}" target="_blank">` : '<a>';
  return `
<div><div class="wsite-image wsite-image-border-none " style="padding-top:${top}px;padding-bottom:${bottom}px;margin-left:0px;margin-right:0px;text-align:${align}">
${linkStart}
<img src="${src}" alt="Imagen" style="display:block;width:auto;max-width:100%">
</a>
<div style="display:block;font-size:90%"></div>
</div></div>
`;
}

const clientColumnsHtml = clientColumns.map((column) => `
					
				${column.map(renderClientLogoHtml).join('\n\n')}
`);

const networks = [
  ['/uploads/1/1/9/7/119720466/fundacion_orig.jpg', 'https://www.recyclapolis.cl'],
  ['/uploads/1/1/9/7/119720466/claro_orig.jpg', 'https://www.claro.cl'],
  ['/uploads/1/1/9/7/119720466/ecomondo_orig.jpg', 'https://unb.ecomondo.com/international-en/?utm_source=referral&utm_medium=banner&utm_campaign=Recyclapolis'],
];

export default function Home() {
  return (
    <div id="wsite-content" className="wsite-elements wsite-not-footer">
      <div className="banner-wrap">
        <div className="wsite-elements wsite-not-footer wsite-header-elements">
          <div className="wsite-section-wrap">
            <div
              className="wsite-section wsite-header-section wsite-section-bg-image"
              style={{
                height: '390px',
                verticalAlign: 'middle',
                backgroundImage: 'url(/uploads/1/1/9/7/119720466/background-images/224326339.jpg)',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: '50% 50%',
                backgroundSize: 'cover',
                backgroundColor: 'transparent',
              }}
            >
              <div className="wsite-section-content">
                <div className="banner">
                  <div className="banner-inner">
                    <div className="wsite-section-elements">
                      <div>
                        <div className="wsite-image wsite-image-border-none" style={{ paddingTop: 0, paddingBottom: 0, marginLeft: 0, marginRight: 0, textAlign: 'inherit' }}>
                          <img src="/uploads/1/1/9/7/119720466/base-slide-fin_orig.jpg" alt="Foto" style={{ width: 'auto', maxWidth: '100%' }} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="wsite-section-wrap">
        <div className="wsite-section wsite-body-section wsite-background-14" style={{ height: 'auto' }}>
          <div className="wsite-section-content">
            <div className="content-wrap container">
              <div className="wsite-section-elements">
                <h2 className="wsite-content-title">Lo que hacemos</h2>
                <div className="paragraph" style={{ textAlign: 'justify' }}>
                  <font size="3">
                    <strong>Recycla se compromete con un desarrollo sostenible y la promoción de la economía circular</strong> al gestionar de manera eficiente una amplia gama de residuos, incluyendo aparatos electrónicos y eléctricos, metales ferrosos y no ferrosos, envases y embalajes, así como residuos peligrosos y otros. Nuestro objetivo es <strong>influir positivamente en los objetivos establecidos por la ley REP y en los Objetivos de Desarrollo Sostenible (ODS)</strong>, <strong>en particular los</strong> <strong>ODS 9, 11, 12 y 13</strong>, como se especifica en la agenda de la ONU para el desarrollo sostenible.
                  </font>
                </div>

                <div className="wsite-multicol">
                  <div className="wsite-multicol-table-wrap" style={{ margin: '0 -15px', paddingTop: '11.40625px' }}>
                    <table className="wsite-multicol-table" style={{ tableLayout: 'fixed', borderCollapse: 'collapse', borderSpacing: 0 }}>
                      <tbody className="wsite-multicol-tbody">
                        <tr className="wsite-multicol-tr">
                          <td className="wsite-multicol-col" style={{ width: '16.666666666667%', padding: '0 15px' }} />
                          {goals.map(([src, alt]) => (
                            <td key={src} className="wsite-multicol-col" style={{ width: '16.666666666667%', padding: '0 15px' }}>
                              <div>
                                <div className="wsite-image wsite-image-border-none" style={{ paddingTop: 0, paddingBottom: 10, marginLeft: 10, marginRight: 10, textAlign: 'center' }}>
                                  <img src={src} alt={alt} style={{ width: 'auto', maxWidth: '100%' }} />
                                </div>
                              </div>
                            </td>
                          ))}
                          <td className="wsite-multicol-col" style={{ width: '16.666666666667%', padding: '0 15px' }} />
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="paragraph" style={{ textAlign: 'justify' }}>
                  <font size="3">
                    Mediante nuestros procesos, buscamos catalizar un cambio de paradigma, pasando de un modelo de economía lineal hacia un enfoque más consciente y sustentable, a través de una <strong>ECONOMÍA CIRCULAR</strong> basada en la generación, comercialización, uso y consumo responsables. <br />
                    <br />
                    En Recycla, nos esforzamos por fomentar la adopción de <strong>prácticas responsables</strong> en todas las etapas de la cadena de valor, promoviendo la reutilización, el reciclaje y la gestión eficiente de los recursos. Trabajamos en estrecha colaboración con nuestros clientes, socios y comunidades para impulsar esta transformación hacia un futuro más sostenible y equitativo.
                  </font>
                </div>

                <div className="wsite-multicol">
                  <div className="wsite-multicol-table-wrap" style={{ margin: '0 -15px', paddingTop: '11.40625px' }}>
                    <table className="wsite-multicol-table" style={{ tableLayout: 'fixed', borderCollapse: 'collapse', borderSpacing: 0 }}>
                      <tbody className="wsite-multicol-tbody">
                        <tr className="wsite-multicol-tr">
                          <td className="wsite-multicol-col" style={{ width: '33.333333333333%', padding: '0 15px' }}>
                            <iframe src="//www.youtube.com/embed/1_f25FcDNGw?wmode=opaque" title="Video 1" frameBorder="0" allowFullScreen />
                          </td>
                          <td className="wsite-multicol-col" style={{ width: '33.177715530657%', padding: '0 15px' }}>
                            <iframe src="//www.youtube.com/embed/1QvOqT1LOQw?wmode=opaque" title="Video 2" frameBorder="0" allowFullScreen />
                          </td>
                          <td className="wsite-multicol-col" style={{ width: '33.333333333333%', padding: '0 15px' }}>
                            <iframe src="//www.youtube.com/embed/KCCuzoR7Bis?wmode=opaque" title="Video 3" frameBorder="0" allowFullScreen />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="wsite-spacer" style={{ height: '28px' }} />

                <div className="paragraph">
                  <strong>
                    <a href="/uploads/1/1/9/7/119720466/p_ambiental_2024.pdf" target="_blank" rel="noreferrer">Nuestra Política Ambiental</a>
                  </strong>{' '}
                  <strong style={{ color: 'rgb(63, 63, 63)' }}>&gt;&gt;</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="wsite-section-wrap">
        <div className="wsite-section wsite-body-section wsite-section-bg-color wsite-background-59" style={{ backgroundColor: '#c5d5bb', backgroundImage: 'none' }}>
          <div className="wsite-section-content">
            <div className="content-wrap container">
              <div className="wsite-section-elements">
                <h2 className="wsite-content-title" style={{ textAlign: 'center' }}>
                  <font size="7">Reporte de Sostenibilidad 2025</font>
                </h2>
                <div className="paragraph" style={{ textAlign: 'justify' }}>
                  <font size="3">
                    En <strong>RECYCLA CHILE S.A.</strong>, como empresa comprometida con el medio ambiente y la economía circular del país, buscamos a través de este <strong>Reporte de Sostenibilidad 2025</strong>, cumplir con nuestra política ambiental, brindar transparencia y visibilización sobre nuestra contribución en la gestión integral de residuos y minimización de la carga ambiental de nuestro sistema industrial sostenible, a través de la medición del impacto de todos nuestros procesos a lo largo de toda la cadena productiva.
                  </font>
                </div>

                <div className="wsite-spacer" style={{ height: '30px' }} />

                <h2 className="wsite-content-title" style={{ textAlign: 'center' }}>
                  <font size="6">Tasa de valorización anual de residuos procesados</font>
                </h2>

                <div className="wsite-multicol">
                  <div className="wsite-multicol-table-wrap" style={{ margin: '0 -15px', paddingTop: '11.40625px' }}>
                    <table className="wsite-multicol-table" style={{ tableLayout: 'fixed', borderCollapse: 'collapse', borderSpacing: 0 }}>
                      <tbody className="wsite-multicol-tbody">
                        <tr className="wsite-multicol-tr">
                          <td className="wsite-multicol-col" style={{ width: '33.333333333333%', padding: '0 15px' }}>
                            {processImages.slice(0, 3).map((src) => (
                              <div key={src} className="wsite-image wsite-image-border-none" style={{ paddingTop: 0, paddingBottom: 0, marginLeft: 0, marginRight: 0, textAlign: 'center' }}>
                                <img src={src} alt="Picture" style={{ width: 'auto', maxWidth: '100%' }} />
                              </div>
                            ))}
                          </td>
                          <td className="wsite-multicol-col" style={{ width: '33.333333333333%', padding: '0 15px' }}>
                            {processImages.slice(3, 6).map((src) => (
                              <div key={src} className="wsite-image wsite-image-border-none" style={{ paddingTop: 0, paddingBottom: 0, marginLeft: 0, marginRight: 0, textAlign: 'center' }}>
                                <img src={src} alt="Picture" style={{ width: 'auto', maxWidth: '100%' }} />
                              </div>
                            ))}
                          </td>
                          <td className="wsite-multicol-col" style={{ width: '33.333333333333%', padding: '0 15px' }}>
                            {processImages.slice(6, 9).map((src) => (
                              <div key={src} className="wsite-image wsite-image-border-none" style={{ paddingTop: 0, paddingBottom: 0, marginLeft: 0, marginRight: 0, textAlign: 'center' }}>
                                <img src={src} alt="Picture" style={{ width: 'auto', maxWidth: '100%' }} />
                              </div>
                            ))}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="wsite-section-wrap">
        <div className="wsite-section wsite-body-section wsite-background-14" style={{ height: 'auto' }}>
          <div className="wsite-section-content">
            <div className="content-wrap container">
              <div className="wsite-section-elements">
                <h2 className="wsite-content-title" style={{ textAlign: 'center' }}>Huella de carbono</h2>
                <div className="paragraph" style={{ textAlign: 'justify' }}>
                  Mediante la evaluación y análisis del ciclo de vida (ACV) de todos nuestros procesos que conllevan el servicio de gestión de residuos, es que <strong>Recycla comprometido por el cuidado del medio ambiente y la sustentabilidad</strong>, ha determinado mediante un instrumento de gestión ambiental voluntario, el cálculo de la Huella de Carbono anual, permitiendo mayor transparencia de nuestros impactos ambientales hacia todos los colaboradores.
                </div>

                <div className="wsite-multicol">
                  <div className="wsite-multicol-table-wrap" style={{ margin: '0 -15px' }}>
                    <table className="wsite-multicol-table" style={{ tableLayout: 'fixed', borderCollapse: 'collapse', borderSpacing: 0 }}>
                      <tbody className="wsite-multicol-tbody">
                        <tr className="wsite-multicol-tr">
                          {footprintImages.map((src) => (
                            <td key={src} className="wsite-multicol-col" style={{ width: '33.333333333333%', padding: '0 15px' }}>
                              <div className="wsite-image wsite-image-border-none" style={{ paddingTop: 0, paddingBottom: 0, marginLeft: 0, marginRight: 0, textAlign: 'center' }}>
                                <img src={src} alt="Foto" style={{ width: 'auto', maxWidth: '100%' }} />
                              </div>
                            </td>
                          ))}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="wsite-section-wrap">
        <div
          className="wsite-section wsite-body-section wsite-section-bg-image wsite-background-4"
          style={{
            height: 'auto',
            verticalAlign: 'middle',
            backgroundImage: 'url(/uploads/1/1/9/7/119720466/background-images/210821861.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '50% 50%',
            backgroundSize: 'cover',
            backgroundColor: 'transparent',
          }}
        >
          <div className="wsite-section-content">
            <div className="content-wrap container">
              <div className="wsite-section-elements">
                <div className="wsite-spacer" style={{ height: '12px' }} />
                <h2 className="wsite-content-title" style={{ textAlign: 'center' }}>Ecoequivalencias</h2>
                <div className="paragraph">Nuestra emisión anual de huella de carbono genera una compensación equivalente a:</div>

                <div className="wsite-multicol">
                  <div className="wsite-multicol-table-wrap" style={{ margin: '0 -15px' }}>
                    <table className="wsite-multicol-table">
                      <tbody className="wsite-multicol-tbody">
                        <tr className="wsite-multicol-tr">
                          <td className="wsite-multicol-col" style={{ width: '50%', padding: '0 15px' }}>
                            {ecoImages.left.map((src) => (
                              <div key={src} className="wsite-image wsite-image-border-none" style={{ paddingTop: 0, paddingBottom: 10, marginLeft: 0, marginRight: 0, textAlign: 'center' }}>
                                <img src={src} alt="Foto" style={{ width: 'auto', maxWidth: '100%' }} />
                              </div>
                            ))}
                          </td>
                          <td className="wsite-multicol-col" style={{ width: '50%', padding: '0 15px' }}>
                            {ecoImages.right.map((src) => (
                              <div key={src} className="wsite-image wsite-image-border-none" style={{ paddingTop: 0, paddingBottom: 10, marginLeft: 0, marginRight: 0, textAlign: 'center' }}>
                                <img src={src} alt="Foto" style={{ width: 'auto', maxWidth: '100%' }} />
                              </div>
                            ))}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="wsite-spacer" style={{ height: '20px' }} />
                <hr className="styled-hr" style={{ width: '100%' }} />
                <div className="wsite-spacer" style={{ height: '40px' }} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="wsite-section-wrap">
        <div
          className="wsite-section wsite-body-section wsite-section-bg-image wsite-background-4"
          style={{
            height: 'auto',
            verticalAlign: 'middle',
            backgroundImage: 'url(/uploads/1/1/9/7/119720466/background-images/210821861.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '50% 50%',
            backgroundSize: 'cover',
            backgroundColor: 'transparent',
          }}
        >
          <div className="wsite-section-content">
            <div className="content-wrap container">
              <div className="wsite-section-elements">
                <div className="wsite-multicol">
                  <div className="wsite-multicol-table-wrap" style={{ margin: '0 -15px' }}>
                    <table className="wsite-multicol-table">
                      <tbody className="wsite-multicol-tbody">
                        <tr className="wsite-multicol-tr">
                          <td className="wsite-multicol-col" style={{ width: '60.854007981483%', padding: '0 15px' }}>
                            <div className="wsite-image wsite-image-border-none" style={{ paddingTop: 10, paddingBottom: 10, marginLeft: 0, marginRight: 0, textAlign: 'center' }}>
                              <img src="/uploads/1/1/9/7/119720466/editor/proceso.png?1527653405" alt="Imagen" style={{ width: 'auto', maxWidth: '100%' }} />
                            </div>
                          </td>
                          <td className="wsite-multicol-col" style={{ width: '36.098998951547%', padding: '0 15px' }}>
                            <div className="wsite-spacer" style={{ height: '21px' }} />
                            <h2 className="wsite-content-title">Cómo funciona?</h2>
                            <div className="paragraph" style={{ textAlign: 'justify' }}>
                              Hacemos la logística inversa del producto, desde el retiro al cliente y/o empresa, hasta su reciclaje y disposición final. Esta estructura varia de acuerdo a las necesidades y funcionamiento logístico de cada cliente.
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="wsite-section-wrap">
        <div
          className="wsite-section wsite-body-section wsite-section-bg-image wsite-background-5"
          style={{
            height: 'auto',
            verticalAlign: 'middle',
            backgroundImage: 'url(/uploads/1/1/9/7/119720466/background-images/1948267827.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '50% 50%',
            backgroundSize: 'cover',
            backgroundColor: 'transparent',
          }}
        >
          <div className="wsite-section-content">
            <div className="content-wrap container">
              <div className="wsite-section-elements">
                <h2 className="wsite-content-title">Nuestro modelo</h2>
                <div className="wsite-multicol">
                  <div className="wsite-multicol-table-wrap" style={{ margin: '0 -25px' }}>
                    <table className="wsite-multicol-table">
                      <tbody className="wsite-multicol-tbody">
                        <tr className="wsite-multicol-tr">
                          <td className="wsite-multicol-col" style={{ width: '42.49530956848%', padding: '0 25px' }}>
                            <div className="paragraph" style={{ textAlign: 'justify' }}>
                              Buscamos contribuir al desarrollo sustentable de la sociedad, compatibilizando el crecimiento económico con la preservación ambiental y la equidad social.
                            </div>
                          </td>
                          <td className="wsite-multicol-col" style={{ width: '57.50469043152%', padding: '0 25px' }}>
                            <div className="wsite-multicol">
                              <div className="wsite-multicol-table-wrap" style={{ margin: '0 -15px' }}>
                                <table className="wsite-multicol-table">
                                  <tbody className="wsite-multicol-tbody">
                                    <tr className="wsite-multicol-tr">
                                      <td className="wsite-multicol-col" style={{ width: '26.427406199021%', padding: '0 15px' }}>
                                        <div className="wsite-image wsite-image-border-none" style={{ paddingTop: 10, paddingBottom: 10, marginLeft: 0, marginRight: 0, textAlign: 'left' }}>
                                          <img src="/uploads/1/1/9/7/119720466/economico_orig.png" alt="Imagen" style={{ width: 'auto', maxWidth: '100%' }} />
                                        </div>
                                      </td>
                                      <td className="wsite-multicol-col" style={{ width: '73.572593800979%', padding: '0 15px' }}>
                                        <div className="wsite-multicol">
                                          <div className="wsite-multicol-table-wrap" style={{ margin: '0 -15px' }}>
                                            <table className="wsite-multicol-table">
                                              <tbody className="wsite-multicol-tbody">
                                                <tr className="wsite-multicol-tr">
                                                  <td className="wsite-multicol-col" style={{ width: '42.128603104213%', padding: '0 15px' }}>
                                                    <div className="wsite-image wsite-image-border-none" style={{ paddingTop: 10, paddingBottom: 10, marginLeft: 0, marginRight: 0, textAlign: 'left' }}>
                                                      <img src="/uploads/1/1/9/7/119720466/ambiental_orig.png" alt="Imagen" style={{ width: 'auto', maxWidth: '100%' }} />
                                                    </div>
                                                  </td>
                                                  <td className="wsite-multicol-col" style={{ width: '57.871396895787%', padding: '0 15px' }}>
                                                    <div className="wsite-image wsite-image-border-none" style={{ paddingTop: 10, paddingBottom: 10, marginLeft: 0, marginRight: 0, textAlign: 'left' }}>
                                                      <img src="/uploads/1/1/9/7/119720466/social_orig.png" alt="Imagen" style={{ width: 'auto', maxWidth: '100%' }} />
                                                    </div>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div style={{ textAlign: 'left' }}>
                  <div style={{ height: 10, overflow: 'hidden' }} />
                  <a className="wsite-button wsite-button-small wsite-button-highlight" href="javascript:;">
                    <span className="wsite-button-inner">NUESTRO SUEÑO</span>
                  </a>
                  <div style={{ height: 10, overflow: 'hidden' }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="wsite-section-wrap">
        <div className="wsite-section wsite-body-section wsite-section-bg-color wsite-background-12" style={{ backgroundColor: '#abc8b6', backgroundImage: 'none' }}>
          <div className="wsite-section-content">
            <div className="content-wrap container">
              <div className="wsite-section-elements">
                <div className="wsite-spacer" style={{ height: 10 }} />
                <div className="wsite-image wsite-image-border-none" style={{ paddingTop: 10, paddingBottom: 10, marginLeft: 0, marginRight: 0, textAlign: 'center' }}>
                  <img src="/uploads/1/1/9/7/119720466/editor/2logos.png?1526533289" alt="Imagen" style={{ width: 'auto', maxWidth: '100%' }} />
                </div>
                <div className="wsite-spacer" style={{ height: 16 }} />
                <h2 className="wsite-content-title" style={{ textAlign: 'center' }}>
                  <font color="#ffffff"><strong><font size="6">Emprendimiento Social</font></strong></font>
                </h2>
                <div className="paragraph" style={{ textAlign: 'center' }}>
                  <span><font color="#ffffff"><font size="5">Recycla es un emprendimiento social del World Economic Forum, cuyo modelo de gestión está basado en un impacto ambiental, social y económico.</font></font></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="wsite-section-wrap">
        <div className="wsite-section wsite-body-section wsite-section-bg-color wsite-background-55" style={{ backgroundColor: '#ffffff', backgroundImage: 'none' }}>
          <div className="wsite-section-content">
            <div className="content-wrap container">
              <div className="wsite-section-elements">
                <h2 className="wsite-content-title" style={{ textAlign: 'center' }}>Nuestros clientes</h2>
                <div className="paragraph" style={{ textAlign: 'center' }}>
                  Estas son empresas comprometidas con el medio ambiente, te invitamos a sumarte.
                </div>

                <div className="wsite-multicol">
                  <div className="wsite-multicol-table-wrap" style={{ margin: '0 -15px', paddingTop: '11.40625px' }}>
                    <table className="wsite-multicol-table" style={{ tableLayout: 'fixed', borderCollapse: 'collapse', borderSpacing: 0 }}>
                      <tbody className="wsite-multicol-tbody">
                        <tr className="wsite-multicol-tr">
                          {clientColumns.map((column, index) => (
                            <td key={index} className="wsite-multicol-col" style={{ width: '14.285714285714%', padding: '0 15px' }} dangerouslySetInnerHTML={{ __html: clientColumnsHtml[index] }}></td>
                          ))}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="wsite-section-wrap">
        <div className="wsite-section wsite-body-section wsite-section-bg-color wsite-background-60" style={{ backgroundColor: '#efefef', backgroundImage: 'none' }}>
          <div className="wsite-section-content">
            <div className="content-wrap container">
              <div className="wsite-section-elements">
                <h2 className="wsite-content-title" style={{ textAlign: 'center' }}>Nuestras redes</h2>
                <div className="wsite-multicol">
                  <div className="wsite-multicol-table-wrap" style={{ margin: '0 -15px' }}>
                    <table className="wsite-multicol-table">
                      <tbody className="wsite-multicol-tbody">
                        <tr className="wsite-multicol-tr">
                          <td className="wsite-multicol-col" style={{ width: '15.586854460094%', padding: '0 15px' }}>
                            <div className="wsite-spacer" style={{ height: 50 }} />
                          </td>
                          {networks.map(([src, href], index) => (
                            <td key={src} className="wsite-multicol-col" style={{ width: index === 0 ? '22.816901408451%' : index === 1 ? '22.535211267606%' : '22.347417840376%', padding: '0 15px' }}>
                              <div className="wsite-image wsite-image-border-none" style={{ paddingTop: 10, paddingBottom: 10, marginLeft: 0, marginRight: 0, textAlign: 'center' }}>
                                <a href={href} target="_blank" rel="noreferrer">
                                  <img src={src} alt="Picture" style={{ width: 'auto', maxWidth: '100%' }} />
                                </a>
                              </div>
                            </td>
                          ))}
                          <td className="wsite-multicol-col" style={{ width: '16.713615023474%', padding: '0 15px' }}>
                            <div className="wsite-spacer" style={{ height: 50 }} />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
